<template>
  <div class="px-2 py-2 xl:py-4 lg:py-6 max-w-xl mx-auto min-h-50" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="mx-auto mb-4 overflow-hidden">
      <div class="flex flex-wrap mt-6 mx-1">
        <div class="signin w-full flex justify-center sm:justify-end min-h-xl">
          <div class="w-full pt-3">
            <div class="dialog__header">
              <h5 class="text-NotoSansBold text-center leading-loose textColorRed text-xl md:text-2xl">
                重設密碼
              </h5>
            </div>
            <div class="dialog__body">
              <form class="bg-white rounded px-2 sm:px-12 py-6" method="POST" v-if="$route.query.token">
                <div class="md:flex md:items-center mb-4 textColorBlack">
                  <div class="md:w-1/3">
                    <label class="block md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular" for="email">
                      輸入註冊Email
                    </label>
                  </div>
                  <div class="md:w-2/3">
                    <input type="email" class="text-sm input-text appearance-none border rounded borderColordarkgray2 w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                    id="username" placeholder="輸入註冊Email" v-model="account" autocomplete="email" name="account" />
                  </div>
                </div>
                <div class="md:flex md:items-center mb-4">
                  <div class="md:w-1/3">
                    <label class="block md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular" for="newPassword">
                      請輸入新密碼
                    </label>
                  </div>
                  <div class="md:w-2/3">
                    <input type="password" class="text-sm input-text appearance-none border borderColordarkgray2 rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                      id="newPassword" placeholder="請輸入8碼至15碼英數字" maxlength="15" v-model="newPassword" autocomplete="new-password" name="newPassword" />
                  </div>
                </div>
                <div class="md:flex md:items-center mb-4">
                  <div class="md:w-1/3">
                    <label class="block md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular" for="resetPassword">
                      確認新密碼
                    </label>
                  </div>
                  <div class="md:w-2/3">
                    <input type="password" class="text-sm input-text appearance-none border borderColordarkgray2 rounded w-full py-3 px-3 textColorDarkBlack leading-tight focus:outline-none focus:border-gray-900"
                    id="resetPassword" placeholder="再次輸入密碼" maxlength="15" v-model="resetPassword" autocomplete="reset-password" name="resetPassword" />
                  </div>
                </div>
                <div class="flex items-center px-0 justify-center md:justify-end">
                    <button class="text-sm button-red text-white py-2 px-6 rounded outline-none focus:outline-none w-full md:w-auto text-NotoSansRegular mb-4 sm:mb-0"
                      type="button" @click="resetPwd" id="btnLogin">
                      確認送出
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import Regex from '@/components/modules/regex'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'ResetPassword',
  data () {
    return {
      account: '',
      newPassword: '',
      resetPassword: ''
    }
  },
  components: {
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  computed: {
  },
  mounted () {
    this.getToken()
  },
  updated () {
  },
  methods: {
    ...mapActions({
      dologin: 'login'
    }),
    async loginAdmin () {
      let self = this
      await this.dologin({ account: self.account, password: self.newPassword })
    },

    getToken () {
      let self = this
      if (!self.$route.query.token) {
        self.$router.push({ name: 'index' })
        self.alertPop('error', '發生錯誤或變更代碼逾時')
        // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '發生錯誤或變更代碼逾時', type: 'alert' })
      }
    },
    resetPwd () {
      let self = this
      let isEqual = self.checkPwdEqual(self.newPassword, self.resetPassword)
      let isRex = self.rexPassword(self.newPassword)

      if ((self.$route.query.token && self.account) && isEqual && isRex) {
        let data = {
          token: self.$route.query.token,
          email: self.account,
          password: self.newPassword,
          password_confirmation: self.resetPassword
        }
        axios.post('/password/reset', data)
          .then((response) => {
            self.alertPop('success', '變更密碼成功')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '變更密碼成功', type: 'check' })
            self.$router.push({ name: 'index' })
            self.loginAdmin()
          })
          .catch(() => {
            self.alertPop('error', '發生錯誤或變更代碼逾時')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '發生錯誤或變更代碼逾時!!', type: 'alert' })
            self.$router.push({ name: 'index' })
          })
      } else {
        self.alertPop('warning', '帳號空白或密碼不一致')
        // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '帳號空白或密碼不一致', type: 'alert' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .box1 img{
  -webkit-box-reflect:below 0 -webkit-linear-gradient(top,rgba(250,250,250,0),rgba(250,250,250,.0) 30%,rgba(250,250,250,.3));
  }
  .dialog__body {
    .fb-btn {
      background-color: #3b5998;
      &:hover {
        background-color: #29487d;
      }
    }
    #my-signin2{
      .abcRioButtonContentWrapper {
        display: flex;
        justify-content: center;
      }
      width: 100% !important;
      .abcRioButton, .abcRioButtonBlue {
        background-color: white;
        width: 100% !important;
        height: 40px !important;
        border-radius: 0.25rem !important;
        height: auto;
        &:hover {
          box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
        }
        .abcRioButtonContents {
        font-weight: 700 !important;
        font-size: 1rem !important;
        color: black;
        }
      }
    }
    .social-login-option:before, .social-login-option:after {
        background-color: #dde1e4;
        content: "";
        display: inline-block;
        height: 1px;
        position: relative;
        vertical-align: middle;
        width: 45%;
    }
    .social-login-option:before {
      right: .5rem;
      // margin-left: -50%;
    }
    .social-login-option:after {
      left: .5em;
      // margin-right: -50%;
    }
  }

  .input-text {
    background-color: white;
    border: 1px solid #cccccc;
    padding: 8px 4px;
    position: relative;
    width: 100%;
    z-index: 3;
  }

  .label-helper {
    position: absolute;
    opacity: 0;
    transition: .2s bottom, .2s opacity;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  .input-text:focus + .label-helper, .input-text:invalid + .label-helper {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
    }

  .input-text:not(:placeholder-shown) ~ label,
  .input-text:-webkit-autofill ~ label {
    bottom: 95%;
    line-height: 1;
    opacity: 1;
  }
</style>
